<template>
  <div>
        <InventoryPageHeader>
      <template #title>
        <i class="fas fa-tablet-alt mr-2 text-primary"></i>All Devices
      </template>
      <template #search>
        <b-form-input v-model="search" placeholder="Search MAC or location..." size="sm" />
      </template>
      <template #actions>
        <base-button size="sm" type="primary" @click="openAddModal">
          <i class="fas fa-plus"></i> Add Device
        </base-button>
        <base-button size="sm" type="primary" @click="$router.push('/import')">
          <i class="fas fa-upload"></i> Import
        </base-button>
        <base-button size="sm" type="outline-primary" @click="$router.push('/scan')">
          <i class="fas fa-camera"></i> Scan
        </base-button>
      <!-- Delete dropdown -->
<b-dropdown size="sm" variant="outline-danger" text="Delete">
  <b-dropdown-item @click="confirmDeleteAllDevices">
    <i class="fas fa-trash-alt mr-1"></i> Delete All
  </b-dropdown-item>
  <b-dropdown-item @click="showDeleteFilterModal = true">
    <i class="fas fa-filter mr-1"></i> Delete by Filter
  </b-dropdown-item>
</b-dropdown>
        <!-- Export dropdown -->
        <!-- Export dropdown -->
<b-dropdown size="sm" variant="outline-success" text="Export" right boundary="viewport">
    <b-dropdown-item @click="showExportFilterModal = true">
    <i class="fas fa-filter mr-1"></i> Export by Filter…
  </b-dropdown-item>
  <b-dropdown-divider></b-dropdown-divider>
  <b-dropdown-item @click="exportCSV">
    <i class="fas fa-file-csv mr-1"></i> Export All CSV
  </b-dropdown-item>
  <b-dropdown-item @click="exportJSON">
    <i class="fas fa-file-code mr-1"></i> Export All JSON
  </b-dropdown-item>
  <b-dropdown-item @click="exportExcel">
    <i class="fas fa-file-excel mr-1"></i> Export All Excel
  </b-dropdown-item>
</b-dropdown>
      </template>
    </InventoryPageHeader>

    <b-container fluid class="mt--6">
      <!-- Filter Toggle -->
      <div class="d-flex justify-content-end mb-2">
        <b-button size="sm" variant="outline-secondary" @click="showFilters = !showFilters">
          <i class="fas fa-filter"></i> Filter
          <i :class="showFilters ? 'fas fa-chevron-up' : 'fas fa-chevron-down'" class="ml-1"></i>
        </b-button>
      </div>

      <!-- Collapsible Filter Bar -->
      <transition name="slide-fade">
        <div v-if="showFilters" class="card card-shadow mb-3">
          <div class="card-body py-2 px-3">
            <div class="d-flex flex-wrap" style="gap:24px;">
              <div v-for="group in filtersConfig" :key="group.id" class="filter-group" style="min-width:200px;">
                <b-dropdown :text="group.label" variant="outline-secondary" size="sm" menu-class="filter-dropdown-menu" :auto-close="false">
                  <div class="px-3 py-2">
                    <b-form-checkbox-group v-model="activeFilters[group.id]" :options="group.options" stacked @change="applyFilters" />
                  </div>
                </b-dropdown>
                <div class="active-filters mt-1">
                  <b-badge v-for="f in activeFilters[group.id]" :key="f" pill variant="info" class="mr-1" style="cursor:pointer;" @click="removeFilter(group.id, f)">
                    {{ f }} <i class="fas fa-times ml-1"></i>
                  </b-badge>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>

      <!-- === ACTIVE DEVICES TABLE === -->
      <b-card no-body class="card-shadow mb-4">
        <b-card-header class="d-flex justify-content-between align-items-center">
          <span><i class="fas fa-play-circle mr-2 text-success"></i>Active Devices ({{ activeDevices.length }})</span>
          <base-button size="sm" type="outline-primary" @click="openAddModal"><i class="fas fa-plus"></i> Add</base-button>
        </b-card-header>
        <b-card-body class="p-0 table-responsive">
          <el-table :data="activeDevices" row-class-name="cursor-pointer" @row-click="goToDetail" style="width:100%;"empty-text="No devices found">
            <el-table-column label="MAC Address" sortable prop="mac">
              <template slot-scope="{ row }">
                <router-link :to="`/devices/${row.mac}`" class="text-primary font-weight-bold">{{ row.mac }}</router-link>
              </template>
            </el-table-column>
            <el-table-column label="Current Location" prop="currentLocation" sortable>
              <template slot-scope="{ row }">
                <router-link :to="`/companies/${encodeURIComponent(row.currentLocation)}`" class="text-primary">{{ row.currentLocation }}</router-link>
              </template>
            </el-table-column>
            <el-table-column label="Status">
              <template slot-scope="{ row }">
                <b-badge :variant="statusBadge(row.currentStatus)">{{ row.currentStatus }}</b-badge>
              </template>
            </el-table-column>
            <el-table-column label="Return Deadline" width="140">
              <template slot-scope="{ row }">
                <template v-if="row.dueDate">
                  <span :class="deadlineClass(row)">{{ formatDueDate(row.dueDate) }}</span><br />
                  <small :class="deadlineClass(row)">{{ deadlineText(row) }}</small>
                </template>
                <span v-else class="text-muted">—</span>
              </template>
            </el-table-column>
            <el-table-column label="Batch">
              <template slot-scope="{ row }">
                <router-link v-if="batchNumber(row)" :to="`/batches/${batchNumber(row)}`" class="text-primary">{{ row.batch }}</router-link>
                <span v-else>{{ row.batch }}</span>
              </template>
            </el-table-column>
            <!-- After the Batch column -->
<el-table-column label="Owner" prop="owner">
  <template slot-scope="{ row }">
    <span v-if="row.owner" class="text-muted">{{ row.owner }}</span>
    <span v-else class="text-muted">—</span>
  </template>
</el-table-column>
            <el-table-column label="Quality Issues">
              <template slot-scope="{ row }">
                <span v-if="!row.qualityIssues" class="text-muted">—</span>
                <b-badge v-for="(issue, idx) in splitIssues(row.qualityIssues)" :key="idx" :variant="'danger'" class="mr-1">{{ issue }}</b-badge>
              </template>
            </el-table-column>
            <el-table-column label="" width="50">
              <template slot-scope="{ row }">
                <base-button size="sm" type="outline-primary" icon @click.native.stop="openEditModal(row)">
                  <i class="fas fa-edit"></i>
                </base-button>
              </template>
            </el-table-column>
               <el-table-column label="" width="50">
  <template slot-scope="scope">
    <div @click.stop="confirmDeleteDevice(scope.row)">
      <base-button size="sm" type="outline-danger" icon>
        <i class="fas fa-trash-alt"></i>
      </base-button>
    </div>
  </template>
</el-table-column>
          </el-table>
        </b-card-body>
      </b-card>

      <!-- === ARCHIVED DEVICES TABLE (collapsible) === -->
      <b-card no-body class="card-shadow">
        <b-card-header class="d-flex justify-content-between align-items-center" @click="showArchived = !showArchived" style="cursor:pointer;">
          <span><i class="fas fa-archive mr-2 text-muted"></i>Archived / Sold / Decommissioned ({{ archivedDevices.length }})</span>
          <i :class="showArchived ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"></i>
        </b-card-header>
        <b-collapse v-model="showArchived">
          <b-card-body class="p-0 table-responsive">
            <el-table :data="archivedDevices" row-class-name="cursor-pointer" @row-click="goToDetail" style="width:100%;"empty-text="No devices found">
              <el-table-column label="MAC Address" sortable prop="mac">
                <template slot-scope="{ row }">
                  <router-link :to="`/devices/${row.mac}`" class="text-muted">{{ row.mac }}</router-link>
                </template>
              </el-table-column>
              <el-table-column label="Current Location" prop="currentLocation" sortable>
                <template slot-scope="{ row }">{{ row.currentLocation }}</template>
              </el-table-column>
              <el-table-column label="Status">
                <template slot-scope="{ row }">
                  <b-badge :variant="statusBadge(row.currentStatus)">{{ row.currentStatus }}</b-badge>
                </template>
              </el-table-column>
              <el-table-column label="Batch">
                <template slot-scope="{ row }">{{ row.batch }}</template>
              </el-table-column>
              <el-table-column label="" width="50">
                <template slot-scope="{ row }">
                  <base-button size="sm" type="outline-secondary" icon @click.native.stop="openEditModal(row)">
                    <i class="fas fa-edit"></i>
                  </base-button>
             
                </template>
              </el-table-column>
             <el-table-column label="" width="50">
  <template slot-scope="scope">
    <div @click.stop="confirmDeleteDevice(scope.row)">
      <base-button size="sm" type="outline-danger" icon>
        <i class="fas fa-trash-alt"></i>
      </base-button>
    </div>
  </template>
</el-table-column>
            </el-table>
          </b-card-body>
        </b-collapse>
      </b-card>

      <!-- Device Form Modal (used for both Add and Edit) -->
      <DeviceFormModal
        :show="!!deviceFormMode"
        :mode="deviceFormMode"
        :device="selectedDevice"
        :initial-mac="initialMac"
        @close="closeFormModal"
        @saved="onDeviceSaved"
      />

    </b-container>
    <!-- Delete by Filter Modal -->
<b-modal v-model="showDeleteFilterModal" title="Delete Devices by Filter" hide-footer>
  <div>
    <b-form-group label="Batch">
      <b-form-select v-model="deleteFilter.batch" :options="batchOptions" size="sm">
        <template v-slot:first>
          <b-form-select-option :value="null">All Batches</b-form-select-option>
        </template>
      </b-form-select>
    </b-form-group>
    <b-form-group label="Company">
      <b-form-select v-model="deleteFilter.company" :options="companyOptions" size="sm">
        <template v-slot:first>
          <b-form-select-option :value="null">All Companies</b-form-select-option>
        </template>
      </b-form-select>
    </b-form-group>
    <b-alert variant="warning" show>
      This will permanently delete <strong>all</strong> devices matching the selected filters.
    </b-alert>
    <b-form-input
      v-model="deleteConfirmText"
      placeholder="Type DELETE to confirm"
      size="sm"
      class="mb-3"
    ></b-form-input>
    <div class="d-flex justify-content-end">
      <b-button variant="secondary" size="sm" @click="showDeleteFilterModal = false">Cancel</b-button>
      <b-button
        variant="danger"
        size="sm"
        class="ml-2"
        :disabled="deleteConfirmText !== 'DELETE' || (!deleteFilter.batch && !deleteFilter.company)"
        @click="executeFilteredDelete"
      >
        Delete
      </b-button>
    </div>
    </div>
</b-modal>

<!-- Export by Filter Modal -->
<b-modal v-model="showExportFilterModal" title="Export Devices by Filter" hide-footer>
  <div>
    <b-form-group label="Batch">
      <b-form-select v-model="exportFilter.batch" :options="batchOptions" size="sm">
        <template v-slot:first>
          <b-form-select-option :value="null">All Batches</b-form-select-option>
        </template>
      </b-form-select>
    </b-form-group>

    <b-form-group label="Company / Location">
      <b-form-select v-model="exportFilter.company" :options="companyOptions" size="sm">
        <template v-slot:first>
          <b-form-select-option :value="null">All Companies</b-form-select-option>
        </template>
      </b-form-select>
    </b-form-group>

    <b-form-group label="Status">
      <b-form-select v-model="exportFilter.status" :options="statusOpts" size="sm">
        <template v-slot:first>
          <b-form-select-option :value="null">All Statuses</b-form-select-option>
        </template>
      </b-form-select>
    </b-form-group>

    <div class="d-flex justify-content-end mt-3">
      <b-button variant="secondary" size="sm" @click="showExportFilterModal = false">Cancel</b-button>
      <b-button variant="success" size="sm" class="ml-2" @click="executeFilteredExport">
        <i class="fas fa-download mr-1"></i> Export
      </b-button>
    </div>
  </div>
</b-modal>
  </div>
</template>


<script>
import { mapState, mapActions } from 'vuex'
import { statusBadge, formatDueDate, deadlineClass, deadlineText } from '@/utils/statusHelpers'
import DeviceFormModal from '@/components/DeviceFormModal.vue'
import InventoryPageHeader from '@/components/InventoryPageHeader.vue'

export default {
  name: 'DeviceList',
  components: { InventoryPageHeader, DeviceFormModal },
  data() {
    return {
      search: '',
      showFilters: false,
      activeFilters: { status: [], location: [], batch: [], qualityIssues: [] },
      filtersConfig: [],
      showArchived: false,
      // Form modal
      deviceFormMode: null,   // 'add' | 'edit' | null
      selectedDevice: null,
      initialMac: '',
           showDeleteFilterModal: false,
      deleteFilter: {
        batch: null,
        company: null
      },
      deleteConfirmText: '',
      showExportFilterModal: false,
      exportFilter: {
        batch: null,
        company: null,
        status: null
      }
    }
  },
  computed: {
    ...mapState('inventory', ['devices', 'companies', 'batches']),
    statusOpts() {
      return ['OK', 'Test', 'Sold', 'Decommissioned', 'RMA'].map(s => ({ value: s, text: s }))
    },
    qualityIssueOpts() {
      const issues = ['Housing cracked', 'Bad speaker', 'Bad buttons', 'Battery issue', 'Screen broken', 'Display mis-positioned', 'Bad charging pins', 'Left LED bad', 'Right LED bad', 'Vibration defect', 'Duplicate MAC', 'opened']
      return issues.map(s => ({ value: s, text: s }))
    },
    companyOpts() { return this.companies.map(c => ({ value: c, text: c })) },
    batchOpts() {
      return this.batches.map(b => {
        const label = `Batch ${b.number} (${b.deliveryDate})`
        return { value: `Batch ${b.number} (${b.deliveryDate})`, text: label }
      })
    },
    filteredDevices() { /* … same as before … */
      let list = this.devices
      if (this.search) {
        const q = this.search.toLowerCase()
        list = list.filter(d => d.mac.toLowerCase().includes(q) || d.currentLocation.toLowerCase().includes(q))
      }
      if (this.activeFilters.status?.length) list = list.filter(d => this.activeFilters.status.includes(d.currentStatus))
      if (this.activeFilters.location?.length) list = list.filter(d => this.activeFilters.location.includes(d.currentLocation))
      if (this.activeFilters.batch?.length) list = list.filter(d => this.activeFilters.batch.includes(d.batch))
      if (this.activeFilters.qualityIssues?.length) {
        list = list.filter(d => {
          const issues = (d.qualityIssues || '').split(/[,.;] +/).map(i => i.trim())
          return this.activeFilters.qualityIssues.some(q => issues.includes(q))
        })
      }
      return list
    },
    companyOptions() {
  return this.companies.map(c => ({ value: c, text: c }))
},
batchOptions() {
  return this.batches.map(b => {
    const label = `Batch ${b.number} (${b.deliveryDate})`
    return { value: label, text: label }
  })
},
    activeDevices() { return this.filteredDevices.filter(d => !['Sold', 'Decommissioned'].includes(d.currentStatus)) },
    archivedDevices() { return this.filteredDevices.filter(d => ['Sold', 'Decommissioned'].includes(d.currentStatus)) }
  },
 async mounted() {
  await this.loadDevices()
  await Promise.all([
    this.$store.dispatch('inventory/loadCompanies'),
    this.$store.dispatch('inventory/loadBatches')
  ])
  this.buildFiltersConfig()
},
  watch: { devices: { handler() { this.buildFiltersConfig() }, deep: true } },
methods: {
    ...mapActions('inventory', ['loadDevices', 'updateDevice', 'addDevice', 'addBatch', 'addCompany', 'deleteDevice']),

    statusBadge,
    formatDueDate,
    deadlineClass,
    deadlineText,

    // Delete method (no local override)
    async confirmDeleteDevice(device) {
      if (!device || !device.mac) {
        alert('Could not identify the device to delete.')
        return
      }
      if (!confirm(`Delete device ${device.mac}?`)) return
      try {
        await this.deleteDevice(device.mac)   // calls the mapped Vuex action
        this.loadDevices()
      } catch (e) {
        alert('Delete failed: ' + (e.message || 'Unknown error'))
      }
    },
        executeFilteredExport() {
      const params = new URLSearchParams()

      if (this.exportFilter.batch) {
        params.append('batch', this.exportFilter.batch)
      }
      if (this.exportFilter.company) {
        params.append('company', this.exportFilter.company)
      }
      if (this.exportFilter.status) {
        params.append('status', this.exportFilter.status)
      }

      // Default to CSV; you can add format selection if needed
      const url = `/api/export/csv?${params.toString()}`
      window.open(url, '_blank')

      // Reset modal state
      this.showExportFilterModal = false
      this.exportFilter = { batch: null, company: null, status: null }
    },
    async executeFilteredDelete() {
  this.showDeleteFilterModal = false

  const params = new URLSearchParams()
  if (this.deleteFilter.batch) params.append('batch', this.deleteFilter.batch)
  if (this.deleteFilter.company) params.append('company', this.deleteFilter.company)

  if (!this.deleteFilter.batch && !this.deleteFilter.company) {
    alert('Please select at least one filter.')
    return
  }

  try {
    const res = await fetch(`/api/devices/delete-all?${params.toString()}`, {
      method: 'DELETE'
    })
    if (!res.ok) {
      const err = await res.json()
      throw new Error(err.detail || 'Deletion failed')
    }
    const data = await res.json()
    alert(`Deleted ${data.deleted} devices.`)
    this.loadDevices()    // refresh the list
  } catch (e) {
    alert('Delete failed: ' + e.message)
  }

  // Reset modal state
  this.deleteFilter = { batch: null, company: null }
  this.deleteConfirmText = ''
},
buildExportUrl(format) {
  const params = new URLSearchParams()

  if (this.search) {
    params.append('search', this.search)
  }

  if (this.activeFilters.status?.length) {
    params.append('status', this.activeFilters.status.join(','))
  }

  if (this.activeFilters.location?.length) {
    params.append('location', this.activeFilters.location.join(','))
  }

  if (this.activeFilters.batch?.length) {
    params.append('batch', this.activeFilters.batch.join(','))
  }

  // If you want qualityIssues in export, add backend support first.
  // if (this.activeFilters.qualityIssues?.length) {
  //   params.append('qualityIssues', this.activeFilters.qualityIssues.join(','))
  // }

  return `/api/export/${format}?${params.toString()}`
},
    exportAll() {
  window.open('/api/export/excel', '_blank')
},
exportCSV() {
  window.open(this.buildExportUrl('csv'), '_blank')
},
exportJSON() {
  window.open(this.buildExportUrl('json'), '_blank')
},
exportExcel() {
  window.open(this.buildExportUrl('excel'), '_blank')
},
    buildFiltersConfig() {
      this.filtersConfig = [
        { id: 'status', label: 'Status', options: this.statusOpts },
        { id: 'location', label: 'Location', options: this.companyOpts },
        { id: 'batch', label: 'Batch', options: this.batchOpts },
        { id: 'qualityIssues', label: 'Quality Issues', options: this.qualityIssueOpts }
      ]
    },
    
    async confirmDeleteAllDevices() {
      // Strong confirmation – user must type a phrase
      const answer = prompt(
        `Are you sure you want to delete ALL devices? This cannot be undone.\nType "DELETE ALL" to confirm:`
      )
      if (answer !== 'DELETE ALL') return

      try {
        const res = await fetch('/api/devices/delete-all', { method: 'DELETE' })
        if (!res.ok) {
          const err = await res.json()
          throw new Error(err.detail || 'Deletion failed')
        }
        const data = await res.json()
        alert(`Deleted ${data.deleted} devices.`)
        this.loadDevices()   // refresh the list
      } catch (e) {
        alert('Delete all failed: ' + e.message)
      }
    },
    batchNumber(device) {
      const match = device.batch?.match(/^Batch\s+(\S+)/)
      return match ? match[1] : null
    },
    splitIssues(issuesStr) {
      return issuesStr ? issuesStr.split(/[,.;] +/).map(i => i.trim()).filter(Boolean) : []
    },
    goToDetail(row) { this.$router.push({ name: 'deviceDetail', params: { mac: row.mac } }) },
    applyFilters() {},
    removeFilter(groupId, value) {
      const idx = this.activeFilters[groupId].indexOf(value)
      if (idx > -1) this.activeFilters[groupId].splice(idx, 1)
    },
    // Form modal
    openAddModal() {
      this.deviceFormMode = 'add'
      this.selectedDevice = null
      this.initialMac = this.$route.query.newDeviceMac || ''
    },
    openEditModal(row) {
      this.deviceFormMode = 'edit'
      this.selectedDevice = row
    },
    closeFormModal() {
      this.deviceFormMode = null
      this.selectedDevice = null
      this.initialMac = ''
    },
    onDeviceSaved() {
      this.closeFormModal()
      this.loadDevices()
    },
   async confirmDeleteDevice(device) {
  if (!device || !device.mac) {
    alert('Could not identify the device to delete.')
    return
  }
  if (!confirm(`Delete device ${device.mac}?`)) return
  try {
    await this.deleteDevice(device.mac)   // Vuex action
    this.loadDevices()                    // refresh list
  } catch (e) {
    alert('Delete failed: ' + (e.message || 'Unknown error'))
  }
},
  }
}
</script>

<style scoped>
.filter-dropdown-menu { max-height: 260px; overflow-y: auto; }
.active-filters { margin-top: 6px; }
</style>